import { safeStorage } from '@/lib/safe-storage'

export const ONBOARDING_STORAGE_KEY = 'mosquarium_onboarding_completed'

export function isOnboardingCompleted(): boolean {
  if (typeof window === 'undefined') return false
  // Флаг хранит именно факт просмотра туториала, а не состояние доступа к камере.
  return safeStorage.getItem(ONBOARDING_STORAGE_KEY) === 'true'
}

export function completeOnboarding(): void {
  if (typeof window === 'undefined') return
  // Пишем навсегда сразу после клика "играть" на последнем шаге онбординга.
  safeStorage.setItem(ONBOARDING_STORAGE_KEY, 'true')
}
